import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_SLIDE_UP_LAYOUT_EXPERIMENT = defineFcm('psf_share_slide_up_layout_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description: 'Gates the share slide-up icons-per-row + show-more layout experiment',
		import: false,
		deprecated: 'FCM no longer in use — safe to delete after 2026-07-25',
		template: {
			enabled: false,
			experimentName: '',
		},
	});
